import { useSearchParams } from 'next/navigation';

const MAX_WIN_QUERY = 'max_win';

export type MaxWinMultiplier = '3x' | '5x';

// Marks whichever terms line uses {{maxWin}}/{{maxWinNok}} so it can be
// swapped for the multiplier-based sentence without restructuring every
// page's per-locale termsContent copy around a new shared placeholder.
export const MAX_WIN_SENTINEL = '__MAX_WIN_SENTINEL__';

const VALID_MULTIPLIERS: MaxWinMultiplier[] = ['3x', '5x'];

// NDB offers can express Maximum win amount either as a calculated money
// figure (existing fs-based logic) or as a multiplier of the Free Spins
// winnings — this reads which mode is requested, defaulting to none (money).
export const useMaxWinFromQuery = (): MaxWinMultiplier | null => {
  const searchParams = useSearchParams();
  const param = searchParams.get(MAX_WIN_QUERY);

  return VALID_MULTIPLIERS.includes(param as MaxWinMultiplier)
    ? (param as MaxWinMultiplier)
    : null;
};
